import script from "./RoleRelationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRelationList.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRelationList.vue?vue&type=style&index=0&id=e48ad4be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48ad4be"]])

export default __exports__